import { render, staticRenderFns } from "./InputTextList.vue?vue&type=template&id=272d7cd0&scoped=true"
import script from "./InputTextList.vue?vue&type=script&lang=js"
export * from "./InputTextList.vue?vue&type=script&lang=js"
import style0 from "./InputTextList.vue?vue&type=style&index=0&id=272d7cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272d7cd0",
  null
  
)

export default component.exports